// Rollen, van laag naar hoog. Elke rol kan alles wat de rollen eronder ook kunnen.
// Dezelfde volgorde staat in firestore.rules en functions/index.js — bij een wijziging
// alle drie aanpassen.
//   trainer      – lezen
//   hoofdtrainer – + accounts van trainers van de eigen club beheren, + extra oefeningen
//   editor       – + seizoensplannen en Training Deck bewerken
//   creator      – alles, bij alle clubs (ook alle rollen toekennen)
export const ROLES = [
  { key: "trainer", label: "Trainer", desc: "Seizoensplannen en oefeningen inzien van zijn/haar club" },
  { key: "hoofdtrainer", label: "Hoofdtrainer", desc: "Eigen oefeningen toevoegen en accounts beheren van andere trainers van zijn/haar club" },
  { key: "editor", label: "Editor", desc: "Bewerken van seizoensplannen" },
  { key: "creator", label: "Creator", desc: "Bewerken en updaten van de website" },
];

export function roleRank(role) {
  // Oude "owner"-rol uit fase 1 telt als creator.
  if (role === "owner") return 3;
  var i = ROLES.findIndex(function (r) { return r.key === role; });
  return i < 0 ? 0 : i;
}

export function roleLabel(role) {
  var r = ROLES[roleRank(role)];
  return r ? r.label : role;
}

export function atLeast(profile, role) {
  return !!profile && roleRank(profile.role) >= roleRank(role);
}

export function isCreator(profile) {
  return atLeast(profile, "creator");
}

// Welke rollen iemand aan een ander mag geven: een creator alle rollen, een
// hoofdtrainer of editor alleen "trainer".
export function assignableRoles(myRole) {
  if (roleRank(myRole) >= 3) return ROLES;
  return ROLES.filter(function (r) { return r.key === "trainer"; });
}

// Mag `me` het account `u` beheren (naam, wachtwoordlink, verwijderen, rol)?
// Nooit jezelf; een creator alles; anderen alleen trainers van de eigen club.
export function canManageAccount(me, u) {
  if (!me || !u || u.uid === me.uid) return false;
  if (isCreator(me)) return true;
  return roleRank(me.role) >= 1 && u.clubId === me.clubId && u.role === "trainer";
}
